import AutoComplete from 'antd/es/auto-complete';
import 'antd/es/auto-complete/style/css';

export default AutoComplete;
